import { Badge } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { InfoPopover, type PopoverSeite } from './InfoPopover.tsx';

export type PartnerTemplate = {
  anzeigename: string;
  beschreibung: string;
};

type PartnerBadgeProps = {
  partnerTemplate: PartnerTemplate;
  infoSeite: PopoverSeite;
};

export function PartnerBadge({
  partnerTemplate,
  infoSeite,
}: PartnerBadgeProps) {
  const { t } = useTranslation();

  return (
    <span className="flex min-w-0 items-center gap-1">
      <Badge type="pill" variant="secondary" className="truncate px-1">
        {partnerTemplate.anzeigename}
      </Badge>
      <InfoPopover
        seite={infoSeite}
        text={partnerTemplate.beschreibung}
        label={t('domain.e2nApi.zugaenge.tabelle.partnerInfoLabel')}
      />
    </span>
  );
}
